import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import basketReducer from './slices/basketSlice';
import locationReducer from './slices/locationSlice';
import saved from './slices/addresses';
import editAddres from './slices/editAddres';
import savePickup from './slices/pickup';
import userAddresses from './slices/userAddresses';
import deliveryTimeSlice from './slices/delivery';
import fulfillment from './slices/fulfillment';

export const store = configureStore({
  reducer: {
    user: userReducer,
    basket: basketReducer,
    location: locationReducer,
    addresses: saved,
    editAddreses: editAddres,
    pickup: savePickup,
    userAddress: userAddresses,
    delivery: deliveryTimeSlice,
    fulfillment,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
